/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import { getConfig } from "@medaica/common/services/util"
import { BookingApiClient } from "./booking-api-client"
import MockBookingApi from "./mock-booking-api"

/**
 * Mock-first (05 §2), but SAFE BY DEFAULT for deploys: any production BUILD
 * (NODE_ENV="production" — every deployed bundle: dev/staging/prod tarballs) uses
 * the REAL API unless the mock is EXPLICITLY enabled, so the fake booking flow can
 * never reach a real domain on the public `/schedule` route. Non-production runs
 * (local `yarn start`, jest) keep the mock on for demos/tests. To demo the mock on
 * a deployed env, set `REACT_APP_D2C_BOOKING_USE_MOCK=true` in that env's .env
 * file; disable it locally with `=false`. Config read via getConfig() per convention.
 */
const USE_MOCK_BOOKING_API =
  process.env.NODE_ENV === "production"
    ? getConfig("D2C_BOOKING_USE_MOCK") === "true"
    : getConfig("D2C_BOOKING_USE_MOCK") !== "false"

const createBookingApi = (buildRealApi: () => BookingApiClient): BookingApiClient => {
  return USE_MOCK_BOOKING_API ? new MockBookingApi() : buildRealApi()
}

export { USE_MOCK_BOOKING_API }
export default createBookingApi
